(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('userGroupsController', userGroupsController);

  /** @ngInject */
  function userGroupsController ($scope, $state, UserGroupsViewModel) {
    var vm = this;
    vm.groups = new UserGroupsViewModel();

    vm.createUserGroup = function () {
      $state.go('app.userGroups.new');
    };

    vm.updateUserGroup = function () {
      $state.go('app.userGroups.edit', {id: vm.groups.selected[0].id});
    };

    vm.onGroupSelected = function(){
      if(vm.groups.selected.length >= 2){
        vm.groups.selected.shift();
      }
    };

    init();

    function init () {
      $scope.$on('$destroy', destroy);
    }

    function destroy () {
      vm.groups.destroy();
    }

  }
})();
